// extracted by mini-css-extract-plugin
export default {"columnHead":"LoadingColumnHead_columnHead__4YIic","loading":"LoadingColumnHead_loading__mnATh"};